import { Component, inject } from '@angular/core';
import {Router} from '@angular/router';
import {AdminService} from '../../../admin/admin.service';
import {Admin} from '../../../admin/admin';

@Component({
    templateUrl: './add-admin-page.component.html',
    styleUrls: ['./add-admin-page.component.scss'],
    standalone: false
})
export class AddAdminPage {
  private adminService = inject(AdminService);
  private router = inject(Router);

  private requestBusy = false;

  onCancelClicked(): void {
    this.navigateToAdmins();
  }

  onAddClicked(admin: Admin): void {
    if (!this.requestBusy) {
      this.requestBusy = true;
      this.adminService.postAdmin$(admin)
        .subscribe(
          () => this.navigateToAdmins(),
          () => this.requestBusy = false,
          () => this.requestBusy = false,
        );
    }
  }

  private navigateToAdmins(): void {
    this.router.navigateByUrl('/admins');
  }
}
